
const data_url = 'https://data.lifeshack.io'
// const data_url = 'http://localhost:8080'
export default {

    insights: {
        getPeopleInsightsUrl: (companyName) => `${data_url}/company/${companyName}/people-insights`
    }
}